import React, { useEffect, useState } from "react";
import Edit from "../../../Assets/img/Edit.svg";
import Delet from "../../../Assets/img/Delete.svg";
import API from "../../Service/Baseservice";
import Loading from "../../../Loading/loading";
import "../BlogTag/Blogtag.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const BlogTag = () => {
  const navigate = useNavigate();
  const [blogtag, setBlogtag] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [languageId, setLanguageId] = useState(1);
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(9);
  const [totalPages, setTotalPages] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    blog_tag_id: "",
    language_id: "",
    blogtag: "",
  });
  const [popup, setPopup] = useState({
    show: false,
    title: "",
    message: "",
    type: "info",
  });
  useEffect(() => {
    fetchBlogtag(false);
  }, [languageId, search, statusFilter]);

  const fetchBlogtag = (shouldResetPage = false) => {
    setLoading(true);
    const payload = {
      language_id: languageId,
      search: search || "",
      status: statusFilter || "",
    };
    API.post("blogtag_list/condition", payload)
      .then((res) => {
        const data = res?.data?.data?.data || res?.data?.data || [];
        setBlogtag(data);
        if (shouldResetPage) {
          setPage(1);
          localStorage.setItem("blogTagPage", 1);
        }
      })
      .catch((err) => console.error("❌ Error fetching Blogtag:", err))
      .finally(() => setLoading(false));
  };


  const filteredBlogtag = blogtag
    .filter((item) => item.active !== 4)
    .filter((item) => {
      const matchesSearch = item.blogtag
        ?.toLowerCase()
        .includes(search.toLowerCase());
      const matchesStatus =
        statusFilter === ""
          ? true
          : statusFilter === "active"
            ? item.status === "active"
            : item.status === "inactive";
      return matchesSearch && matchesStatus;
    });

  const start = (page - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const paginatedBlogtag = filteredBlogtag.slice(start, end);

  useEffect(() => {
    setTotalPages(Math.ceil(filteredBlogtag.length / rowsPerPage));
  }, [filteredBlogtag, rowsPerPage]);

  console.log(
    `📑 Showing items ${start + 1}–${Math.min(
      end,
      filteredBlogtag.length
    )} of ${filteredBlogtag.length}`
  );

  const handleToggleStatus = (id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    API.post("blogtag_status/update", {
      blog_tag_id: id,
      status: newStatus,
    })
      .then(() => fetchBlogtag())
      .catch((err) => console.error("Failed to update status:", err));
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowPopup(true);
  };

  const confirmDelete = () => {
    if (!deleteId) return;
    API.post("blogtag_delete/update", {
      blog_tag_id: deleteId,
      active: 4,
    })
      .then(() => {
        fetchBlogtag();
        setShowPopup(false);
        setDeleteId(null);
      })
      .catch((err) => console.error("Failed to delete Blogtag:", err));
  };

  const handleAddClick = () => {
    setIsEditing(false);
    setFormData({
      blog_tag_id: "",
      language_id: languageId,
      blogtag: "",
      status: "active",
      createdBy: "1",
      updatedBy: "1",
    });
    setShowForm(true);
  };

  const handleEditClick = (item) => {
    console.log("✏️ Editing BlogTag Item:", item);
    setIsEditing(true);
    setFormData({
      blog_tag_id: item.blog_tag_id,
      language_id: item.language_id,
      blogtag: item.blogtag,
      status: item.status,
      createdBy: "1",
      updatedBy: "1",
    });
    setShowForm(true);
  };

  const handleSave = () => {
    console.log("📝 Saving BlogTag FormData:", formData);
    if (!formData.language_id || !formData.blogtag) {
      return setPopup({
        show: true,
        title: "Warning",
        message: "Please fill all fields ",
        type: "info",
      });
    }
    setLoading(true);

    const endpoint = isEditing ? "blogtag_edit/update" : "add_blogtag/add";
    const payload = isEditing
      ? {
        blog_tag_id: formData.blog_tag_id,
        language_id: formData.language_id,
        blogtag: formData.blogtag,
        status: formData.status,
        active: 1,
        updatedBy: "1",
      }
      : {
        language_id: formData.language_id || languageId,
        blogtag: formData.blogtag,
        status: "active",
        createdBy: "1",
        updatedBy: "1",
      };

    console.log("📤 API Payload:", payload);
    API.post(endpoint, payload)
      .then(() => {
        setPopup({
          show: true,
          title: "Success",
          message: isEditing
            ? "BlogTag updated successfully!"
            : "BlogTag added successfully!",
          type: "success",
        });

        fetchBlogtag();
        setShowForm(false);
      })
      .catch((err) => {
        console.error(isEditing ? "Failed to update" : "Failed to add", err);

        setPopup({
          show: true,
          title: "Error",
          message: "Something went wrong. Please try again.",
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 1) setPage(page - 1);
  };
  useEffect(() => {
    if (location.state?.page) {
      setPage(location.state.page);

      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);
  return (
    <div className="category-container1">
      <div className="category-header1">
        <h2 className="category-title1">Blog Tag</h2>
        <button onClick={handleAddClick} className="add-btn">
          <strong>+</strong> Add BlogTag
        </button>
      </div>

      {/* Filters */}
      <div className="category-filter-row1">
        <div className="category-filter-block1">
          <label>Search By</label>
          <div className="category-input-container1">
            <input
              placeholder="Search BlogTag"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
                localStorage.setItem("blogTagPage", 1);
              }}
              className="category-input-field1"
            />
          </div>
        </div>

        <div className="category-filter-block1">
          <label>Status</label>
          <div className="category-input-container1">
            <select
              className="category-input-field1"
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setPage(1);
                localStorage.setItem("blogTagPage", 1);
              }}
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>
        {/* Language */}
        <div className="category-filter-block1">
          <label>Language</label>
          <div className="category-input-container1">
            <select
              onChange={(e) => {
                setLanguageId(Number(e.target.value));
                setPage(1);
              }}
              value={languageId}
              className="input-field"
            >
              <option value="1">English</option>
              <option value="2">Français</option>
            </select>
          </div>
        </div>
      </div>

      {/* BlogTag List */}
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="category-grid2">
            {paginatedBlogtag.length > 0 ? (
              paginatedBlogtag.map((item) => (
                <div className="category-card1" key={item.blog_tag_id}>
                  <p>{item.blogtag}</p>
                  <div className="category-card-footer1">
                    <div className="status-container">
                      <label className="category-switch">
                        <input
                          type="checkbox"
                          checked={item.status === "active"}
                          onChange={() =>
                            handleToggleStatus(item.blog_tag_id, item.status)
                          }
                        />
                        <span className="category-slider round">
                          <span className="category-switch-label">
                            {item.status === "active" ? "ON" : "OFF"}
                          </span>
                        </span>
                      </label>
                    </div>
                    <div className="action-buttons1">
                      <img
                        src={Edit}
                        alt="Edit"
                        className="icon-edit"
                        onClick={() => handleEditClick(item)}
                      />
                      <img
                        src={Delet}
                        alt="Delete"
                        className="icon-delete"
                        onClick={() => handleDeleteClick(item.blog_tag_id)}
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-faq-text">No BlogTags found.</p>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination-container">
              <button
                className="pagination-btn"
                onClick={handlePrev}
                disabled={page === 1}
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
                <button
                  key={num}
                  className={`pagination-btn ${page === num ? "active" : ""}`}
                  onClick={() => setPage(num)}
                >
                  {num}
                </button>
              ))}

              <button
                className="pagination-btn"
                onClick={handleNext}
                disabled={page === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </>
      )}

      {/* Delete Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h3>Confirm Delete</h3>
            <p>Are you sure you want to delete this BlogTag?</p>
            <div className="popup-buttons">
              <button className="cancel-btn " onClick={() => setShowPopup(false)}>
                Cancel
              </button>
              <button className="btn delete-btn" onClick={confirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Form */}
      {showForm && (
        <div className="blogtag-popup-overlay">
          <div className={`blogtag-popup-box ${isEditing ? "edit-mode" : "add-mode"}`}>
            <h3>{isEditing ? "Edit BlogTag" : "Add BlogTag"}</h3>
            {!isEditing && (
              <div className="blogtag-admin-form-group">
                <label>Language <span className="required">*</span></label>
                <select
                  style={{ width: "100%" }}
                  name="language_id"
                  value={formData.language_id ?? ""}
                  onChange={(e) => setFormData({ ...formData, language_id: e.target.value })}
                >
                  <option value="">Select Language</option>
                  <option value="1">English</option>
                  <option value="2">Français</option>
                </select>
              </div>
            )}

            <div className="blogtag-admin-form-group">
              <label>Blog Tag Name <span className="required">*</span></label>
              <input
                type="text"
                name="blogtag"
                value={formData.blogtag}
                onChange={(e) => setFormData({ ...formData, blogtag: e.target.value })}
                placeholder="Enter BlogTag"
              />
            </div>

            <div className="blogtag-popup-buttons">
              <button className="cancel-btn " onClick={() => setShowForm(false)}>
                Back
              </button>
              <button className="btn saves-btn" onClick={handleSave}>
                {isEditing ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Popup */}
      {popup.show && (
        <div className="popup-overlay">
          <div className={`popup-box popup-${popup.type}`}>
            <h3>{popup.title}</h3>
            <p>{popup.message}</p>
            <div className="popup-buttons">
              <button
                className="btn ok-btn"
                onClick={() => setPopup({ ...popup, show: false })}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogTag;
